import { render, staticRenderFns } from "./SportelloTabelloneCronologiaView.vue?vue&type=template&id=347058e3&"
import script from "./SportelloTabelloneCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./SportelloTabelloneCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports